import { WeaveThemeValues } from '../../../component-theme/theme-types';
import { PopoverMenuStyles } from './popover-menu.styles';

export type PopoverMenuDividerProps = {
  color?: WeaveThemeValues['Color'];
};
export function PopoverMenuDivider({ color }: PopoverMenuDividerProps) {
  const styles = PopoverMenuStyles.divider({ color });

  return <div css={styles} />;
}
